import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../../../enumerations/queryKey";
import { apiGetStatistics } from "../service";

export const useGetStatistics = ({ options }) => {
  return useQuery([queryKey.STATISTICS], () => apiGetStatistics({}).then((res) => res.data.data), {
    ...options,
  });
};
